'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../ipns/index.js');
var config = require('../ipns/routing/config.js');
var offlineDatastore = require('../ipns/routing/offline-datastore.js');
var errors = require('../errors.js');
var debug = require('debug');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

const log = debug__default["default"]('ipfs:components:ipns');
class IPNSAPI {
  constructor(options = { pass: '' }) {
    this.options = options;
    this.offline = null;
    this.online = null;
  }
  getIPNS() {
    const ipns = this.online || this.offline;
    if (ipns) {
      return ipns;
    } else {
      throw new errors.NotInitializedError();
    }
  }
  get routing() {
    return this.getIPNS().routing;
  }
  startOffline({repo, peerId, keychain}) {
    if (this.offline != null) {
      throw new errors.AlreadyInitializedError();
    }
    log('initializing IPNS keyspace');
    const routing = new offlineDatastore.OfflineDatastore(repo);
    const ipns = new index.IPNS(routing, repo.datastore, peerId, keychain, this.options);
    this.offline = ipns;
  }
  async startOnline({libp2p, repo, peerId, keychain}) {
    if (this.online != null) {
      throw new errors.AlreadyInitializedError();
    }
    const routing = config.createRouting({
      libp2p,
      repo,
      peerId,
      options: this.options
    });
    const ipns = new index.IPNS(routing, repo.datastore, peerId, keychain, this.options);
    await ipns.republisher.start();
    this.online = ipns;
  }
  async stop() {
    const ipns = this.online;
    if (ipns) {
      await ipns.republisher.stop();
      this.online = null;
    }
  }
  publish(privKey, value, lifetime) {
    return this.getIPNS().publish(privKey, value, lifetime);
  }
  resolve(name, options) {
    return this.getIPNS().resolve(name, options);
  }
  initializeKeyspace(privKey, value) {
    return this.getIPNS().initializeKeyspace(privKey, value);
  }
}

exports.IPNSAPI = IPNSAPI;
